// client/src/components/watchdog/Toast.jsx
// Dismissible inline toast/banner with auto-fade.

import React, { useEffect, useState } from "react";

const typeColors = {
    error:   { bg: "rgba(239, 68, 68, 0.12)", border: "rgba(239, 68, 68, 0.35)", text: "#fca5a5", icon: "\u274c" },
    success: { bg: "rgba(16, 185, 129, 0.12)", border: "rgba(16, 185, 129, 0.35)", text: "#6ee7b7", icon: "\u2705" },
    warning: { bg: "rgba(245, 158, 11, 0.12)", border: "rgba(245, 158, 11, 0.35)", text: "#fcd34d", icon: "\u26a0\ufe0f" },
    info:    { bg: "rgba(59, 130, 246, 0.12)", border: "rgba(59, 130, 246, 0.35)", text: "#93c5fd", icon: "\u2139\ufe0f" },
};

export default function Toast({ message, type = "info", duration = 8000, onDismiss }) {
    const [visible, setVisible] = useState(true);
    const [fading, setFading] = useState(false);

    useEffect(() => {
        if (duration <= 0) return;
        const fadeTimer = setTimeout(() => setFading(true), duration - 400);
        const removeTimer = setTimeout(() => {
            setVisible(false);
            if (onDismiss) onDismiss();
        }, duration);
        return () => { clearTimeout(fadeTimer); clearTimeout(removeTimer); };
    }, [duration, onDismiss]);

    if (!visible) return null;

    const c = typeColors[type] || typeColors.info;

    return (
        <div
            style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                padding: "10px 16px",
                background: c.bg,
                border: `1px solid ${c.border}`,
                borderRadius: "8px",
                fontSize: "13px",
                color: c.text,
                transition: "opacity 0.4s ease",
                opacity: fading ? 0 : 1,
                marginBottom: "8px",
            }}
        >
            <span style={{ fontSize: "14px" }}>{c.icon}</span>
            <span style={{ flex: 1, lineHeight: "1.4" }}>{message}</span>
            <button
                onClick={() => { setVisible(false); if (onDismiss) onDismiss(); }}
                style={{
                    background: "none",
                    border: "none",
                    color: c.text,
                    cursor: "pointer",
                    fontSize: "16px",
                    padding: "0 4px",
                    opacity: 0.7,
                }}
                title="Dismiss"
            >
                \u00d7
            </button>
        </div>
    );
}
